import { isAuth } from "../../helpers/cookies";
export const COMPANY_URL = '/company';
export const USER_URL = '/user';
export const GET_COMPANY_USERS_URL = `company/${isAuth().company_id}/user`;
export const CREATE_ACCOUNT = `/company/${isAuth().company_id}/user`;
export const GET_COMPANY_PROCESS = `/company/process`